import { fetchAuthenticatedFileBlob } from './api';
import type { PortalHelpRole } from '../config/portalHelpContent';

const API_PATH_BY_ROLE: Record<PortalHelpRole, string> = {
  apprenant: '/portal-help/apprenant/pdf',
  formateur: '/portal-help/formateur/pdf',
  partenaire: '/portal-help/partenaire/pdf',
  admin: '/portal-help/admin/pdf',
};

const FILENAME_BY_ROLE: Record<PortalHelpRole, string> = {
  apprenant: 'guide-apprenant-jconsult-academia.pdf',
  formateur: 'guide-formateur-jconsult-academia.pdf',
  partenaire: 'guide-partenaire-jconsult-academia.pdf',
  admin: 'guide-administration-jconsult-academia.pdf',
};

export async function downloadPortalHelpPdf(portal: PortalHelpRole): Promise<void> {
  const { blobUrl } = await fetchAuthenticatedFileBlob(API_PATH_BY_ROLE[portal]);
  const anchor = document.createElement('a');
  anchor.href = blobUrl;
  anchor.download = FILENAME_BY_ROLE[portal];
  anchor.click();
  URL.revokeObjectURL(blobUrl);
}
